// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import pic1 from "../../assets/DamImage.png";
// import pic2 from "../../assets/Bridges.png";
// import pic3 from "../../assets/images/pfimg2.jpg";
// import pic4 from "../../assets/images/pfimg1.jpg";
// // import pic5 from "../../assets/images/pfimg4.jpg";
// import pic6 from "../../assets/images/pfimg5.jpg";
// import pic7 from "../../assets/images/pfimg7.jpg";
// import pic8 from "../../assets/images/pfimg6.jpg";

// const FifthSection = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       easing: "ease-in-out",
//       once: false,
//     });
//   }, []);
//   return (
//     <div className="bg-gray-100 py-10 px-5 md:px-10 lg:px-20">
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         <div
//           className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
//           data-aos="fade-right"
//         >
//           <img
//             src={pic1}
//             alt="Sluice Gates"
//             className="w-full h-64 md:h-80 object-fill"
//             data-aos="zoom-in"
//           />
//           <div className="p-6 flex-grow">
//             <p
//               className="text-gray-700 text-md md:text-lg leading-relaxed  heebo text-justify"
//               data-aos="fade-up"
//             >
//               Sailesh Dani, a trailblazer in mechanical manufacturing,
//               introduced sandblasting with epoxy treatment for the first time in
//               Odisha’s mega spillway sluice gates. With an unwavering{" "}
//               <span className="font-bold">15-year service</span> to the Hirakud
//               Dam, he revolutionized maintenance techniques and enhanced
//               durability.
//             </p>
//           </div>
//         </div>

//         <div
//           className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
//           data-aos="fade-left"
//           data-aos-delay="100"
//         >
//           <img
//             src={pic2}
//             alt="Gantry Crane Disc Plates"
//             className="w-full h-64 md:h-80 object-fill"
//             data-aos="zoom-in"
//           />
//           <div className="p-6 flex-grow">
//             <p
//               className="text-gray-700 text-md md:text-lg leading-relaxed text-justify heebo"
//               data-aos="fade-up"
//             >
//               He also pioneered the manufacturing of 100-ton gantry crane disc
//               plates through his innovative processes, showcasing his
//               engineering expertise. As a visionary, Sailesh Dani is now working
//               towards introducing automated systems for spillway sluice gates,
//               setting new benchmarks in dam infrastructure.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FifthSection;

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import pic1 from "../../assets/DamImage.png";
import pic2 from "../../assets/Bridges.png";
import pic3 from "../../assets/images/pfimg1.png";
import pic4 from "../../assets/images/Frame3.png";
import pic6 from "../../assets/images/Frame5.png";
import pic7 from "../../assets/images/pfimg1.png";
import pic8 from "../../assets/images/Frame4.png";
import pic9 from "../../assets/images/Frame2.png";
import pic10 from "../../assets/images/solo1.png";
import pic11 from "../../assets/images/Frame8.png";
import pic12 from "../../assets/images/Frame11.png";

const FifthSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);

  return (
    <div className="bg-gray-100 py-10 px-5 md:px-10 lg:px-20">
      {/* Key Contributions Cards */}
      <div className="mb-16">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-8"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          My Key Contributions
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-right"
            data-aos-delay="0"
          >
            <img
              src={pic3}
              alt="Medical Simulation"
              className="w-full object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                A Pioneer in Medical Simulation & Virtual Skill Labs
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                My core expertise lies in designing, supplying, and implementing
                Virtual Skill Labs for medical colleges, equipped with advanced
                features for virtual dissection, gross & regional anatomy,
                clinical skill training, biochemistry & physiology labs, and
                high-fidelity simulation modules. Today, my systems are
                installed across all major medical colleges in Odisha.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <img
              src={pic8}
              alt="Digital Science Labs"
              className="w-full  object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                Transforming School Learning Through Digital Science Labs
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                I have successfully introduced Digital Learning Science Systems
                for students of Classes 8, 9, and 10, particularly for regional
                and rural schools. These digital platforms deliver interactive
                modules in physics, chemistry, biochemistry, anatomy, and lab
                sciences aligned with CBSE and ICSE curriculum frameworks.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <img
              src={pic12}
              alt="Global Research"
              className="w-full object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                Global Research Exposure & International Collaboration
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                My passion for innovation keeps me engaged with global research
                communities. I have participated in leading international
                conferences including MEDICA in Düsseldorf, Germany—the world's
                largest medical technology event—exploring new-generation
                simulation systems and diagnostic innovations.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Cards Section */}
      <div>
        <h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-8"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          My Vision & Commitment
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* Card 4 - International Exposure */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-right"
            data-aos-delay="0"
          >
            <img
              src={pic9}
              alt="International Exposure"
              className="w-full h-64 md:h-80 object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                Global Exposure & International Standards
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                My international exposure spans across Rome, Belgium, France,
                Iran, UAE, Switzerland, Germany, Netherlands, Mauritius,
                Malaysia, Spain, Czech Republic, England, and Singapore. These
                global engagements inspire my work, enabling me to introduce
                solutions that meet international standards of accuracy, safety,
                and educational excellence.
              </p>
            </div>
          </div>

          {/* Card 5 - Mission */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <img
              src={pic10}
              alt="Mission"
              className="w-full h-64 md:h-80 object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                My Mission: Democratizing Quality Learning
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                To democratize high-quality learning by integrating global
                technology into India's medical colleges and regional schools. I
                believe that every student—regardless of geography or
                background—deserves access to premium learning tools, immersive
                experiences, and technology-enabled classrooms.
              </p>
            </div>
          </div>

          {/* Card 6 - Commitment */}
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <img
              src={pic11}
              alt="Commitment"
              className="w-full h-64 md:h-80 object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-800 mb-3">
                Unwavering Commitment to Excellence
              </h3>
              <p className="text-gray-700 text-xs sm:text-sm lg:text-base leading-relaxed heebo text-justify">
                I remain committed to continuous innovation, global-standard
                technology adoption, and strengthening India's academic
                ecosystem. Supporting institutions with reliable and impactful
                solutions while empowering students to excel in a competitive
                world drives my every endeavor.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Infrastructure Section */}
      <div className="mb-16">
        <h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-8"
          data-aos="fade-down"
          data-aos-duration="1000"
        >
          Infrastructure & Innovation
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-right"
          >
            <img
              src={pic1}
              alt="Sluice Gates"
              className="w-full h-64 md:h-80 object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <p
                className="text-gray-700 text-md md:text-lg leading-relaxed heebo text-justify"
                data-aos="fade-up"
              >
                Sailesh Dani, a trailblazer in mechanical manufacturing,
                introduced sandblasting with epoxy treatment for the first time
                in Odisha's mega spillway sluice gates. With an unwavering{" "}
                <span className="font-bold">15-year service</span> to the
                Hirakud Dam, he revolutionized maintenance techniques and
                enhanced durability.
              </p>
            </div>
          </div>

          <div
            className="bg-white rounded-lg shadow-lg overflow-hidden h-full w-full flex flex-col"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <img
              src={pic2}
              alt="Gantry Crane Disc Plates"
              className="w-full h-64 md:h-80 object-cover"
              data-aos="zoom-in"
            />
            <div className="p-6 flex-grow">
              <p
                className="text-gray-700 text-md md:text-lg leading-relaxed text-justify heebo"
                data-aos="fade-up"
              >
                He also pioneered the manufacturing of 100-ton gantry crane disc
                plates through his innovative processes, showcasing his
                engineering expertise. As a visionary, Sailesh Dani is now
                working towards introducing automated systems for spillway
                sluice gates, setting new benchmarks in dam infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FifthSection;
